'use strict';

var _ = require('lodash');
var KpiRibbonController = function KpiRibbonController($scope, dataRetrieverService, constantsService, currentStateCriteriaService, kpiRibbonService, optWeekService, $q) {
  $scope.uniqueId = 'kpi-ribbon-' + Math.random().toString().substr(2);
  $scope.loadingMetrics = false;
  function restoreCollapsedProperty(kpiData, oldKpiData) {
    if (oldKpiData) {
      for (var i = 0; i < oldKpiData.length && i < kpiData.length; i++) {
        if (oldKpiData[i].name === kpiData[i].name) {
          kpiData[i].collapsed = oldKpiData[i].collapsed;
        }
      }
    }
  }
  function getRetrieverMode(screen, mode) {
    var retrieverMode = mode;
    if (screen === constantsService.FLIGHT_SCREEN && currentStateCriteriaService.isPostDeparture()) {
      retrieverMode = $scope.postDepartureModeName;
    }
    return retrieverMode;
  }
  $scope.retrieveData = function (event) {
    if (typeof $scope.canRetrieveData === 'function' && !$scope.canRetrieveData(event)) {
      return;
    }
    $scope.loadingMetrics = true;
    var screen = constantsService[$scope.screen];
    if (!$scope.isCollapsed) {
      var primaryDataPromise = getPrimaryDataPromise(screen);
      var secondaryDataPromise = getSecondaryDataPromise();
      return $q.all([primaryDataPromise, secondaryDataPromise]).then(_.spread(function (primaryData, secondaryData) {
        var data = _.merge(primaryData, secondaryData);
        return $scope.generateKpiItems(data);
      }));
    }
  };
  function getPrimaryDataPromise(screen) {
    return dataRetrieverService.getDataRetriever(screen, getRetrieverMode(screen, $scope.mode)).retrieveComponentData('kpi-ribbon');
  }
  function getSecondaryDataPromise() {
    if ($scope.secondaryData) {
      return $scope.secondaryData();
    } else {
      return $q.when();
    }
  }
  $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', $scope.retrieveData);
  function getFlightKpiMode(kpiModeName) {
    var isPostDepartureMode = currentStateCriteriaService.isPostDeparture() || false;
    var isSeasonalAverage = _.get($scope, 'screenState.selectedReference') === 'seasonalAverage';
    if (isPostDepartureMode) {
      return kpiModeName + 'PostDeparture';
    }
    if (isSeasonalAverage) {
      return kpiModeName + 'SeasonalAverage';
    }
    return kpiModeName;
  }
  $scope.generateKpiItems = function (data) {
    var oldKpiData = $scope.kpiItems;
    var kpiModeName = $scope.mode;
    if (!_.isEmpty(data)) {
      $scope.loadingMetrics = false;
    }
    switch ($scope.mode) {
      case constantsService.CABIN_MODE:
        kpiModeName = getFlightKpiMode(kpiModeName);
        break;
      case constantsService.MARKET_PRODUCT_GROUP_MODE:
        kpiModeName = 'market';
        break;
      case constantsService.ROM_ANALYSIS_SKINNY_SERVICES_MODE:
      case constantsService.ROM_SUMMARY_MODE:
        kpiModeName = 'ROM';
        break;
    }
    $scope.kpiItems = kpiRibbonService.generateItems(kpiModeName, data);
    $scope.kpiItems.forEach(function (d) {
      d.collapsable = _.some(d.metrics, {
        hidden: true
      });
    });
    $scope.kpiItems.forEach(function (item) {
      if (item.collapsable && $scope.showKpiTarget) {
        item.collapsed = $scope.showKpiTarget;
      }
    }, this);
    restoreCollapsedProperty($scope.kpiItems, oldKpiData);
  };
};
KpiRibbonController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'CurrentStateCriteriaService', 'KpiRibbonService', 'OptWeekService', '$q'];
module.exports = KpiRibbonController;